import { DEFAULT_NUMBER_OF_IMAGES, HEADLINE_OVER_IMAGES_TEXT } from "./components/ExploreOptions/constant";
import { AssetTypeEnum, LANGUAGE } from "./components/ReviewAssets/components/constants";
import { ExploreOptions } from "./components/ExploreOptions/types";
import { ImageOutputKey, LanguageModelOutputs } from "../concepting/components/StepFour/types";

export const steps = [
  { step: 1, label: "Explore options" },
  { step: 2, label: "Add inputs" },
  { step: 3, label: "Start creating" },
  { step: 4, label: "Confirm details" },
];
export const BEGIN_PROCESS_REQUIREMENTS_BRIEF =
  "Adding a brief can help you create more effective content by providing creative insights about your project and audiences. Review our brief guidelines for more advice on getting the best possible results.";

export const ASSET_GEN_BRIEF_CONSTANTS = {
  STEP_TITLE_BEGIN_PROCESS: "UPLOAD YOUR BRIEF",
  STEP_TITLE_CAMPAIGN_REVIEW: "REVIEW YOUR CAMPAIGN DETAILS",
  STEP_DESCRIPTION:
    "Your brief document has been uploaded. You can adjust the project summary and audience insights below to include additional information. Keep in mind that narrow, contextually specific inputs tend to outperform broad descriptions.",
};

export const computeImageProperties = (
  stepOneData: ExploreOptions,
): { areMultipleAssets: boolean; isHeadlineOverImages: boolean; imageKey: ImageOutputKey } => {
  const { numberOfImages, specifications, assetType } = stepOneData;
  const isVisualAsset = assetType === AssetTypeEnum.Visual || assetType === AssetTypeEnum.VisualAndText;
  const areMultipleAssets = isVisualAsset ? +numberOfImages > +DEFAULT_NUMBER_OF_IMAGES : false;
  return {
    areMultipleAssets,
    isHeadlineOverImages: specifications.label === HEADLINE_OVER_IMAGES_TEXT,
    imageKey: areMultipleAssets ? "imageGroup" : "image",
  };
};

export const ERROR_MESSAGES = {
  INCOMPLETE_GENERATION: (replaceImagesButtonText: string) =>
    `We’re sorry, but your generation did not produce a full set of images. Please click "${replaceImagesButtonText}" if you need a full set.`,
};

export const getNumberOfAssetsGenerated = (modelOutputs: LanguageModelOutputs) => {
  const { description, imageGroup, videoScript } = modelOutputs?.languages?.[LANGUAGE.ENGLISH] ?? {};

  const noOfTextAssets = [description, videoScript].filter(Boolean).length;
  const noOfImagesGenerated = imageGroup?.length ?? 0;

  return String(noOfTextAssets + noOfImagesGenerated);
};
